module.exports = __webpack_public_path__ + "static/media/lg-login-en.722fd97d.png";